/* eslint-disable no-restricted-syntax -- these are not user-facing strings */
import type { IconType } from "@/react/components/shared/Icon";

export const TEMPLATE_ICONS: Record<string, IconType> = {
  ai_agent_answers_post: "16-ai-action-white",
  ai_curate_home_feed: "16-page-check-form",
  ai_moderate_new_comments: "16-bubble-alert-payment",
  ai_moderate_new_posts: "16-bubble-alert-payment",
  ai_offers_help_after_failed_quiz: "16-checklist",
  ai_welcomes_new_members: "16-raising-hand-greet",
  ai_promotes_upcoming_events: "16-calendar-clock-event",
  ai_recaps_completed_lesson: "16-star-lines",
  ai_renames_titles: "16-rename",
  add_members_to_space_on_tag_assignment: "16-group-member",
  assign_tag_on_post_comment: "16-tag-comment",
  bulk_add_members_to_space: "16-people-add-bulk",
  duplicate_members_over_to_another_space: "16-square-behind-square-clone",
  remove_members_from_space_on_tag_removal: "16-people-remove",
  join_space_message: "16-raising-hand-greet",
  email_new_members_on_joining_a_space: "16-raising-hand-greet",
  tag_members_on_join_space: "16-target-arrow-tag",
  add_member_to_space_by_tag: "16-shuffle-target-member",
  congratulate_members_on_course_completion: "16-medal-course",
  email_members_on_course_completion: "16-medal-course",
  message_members_who_have_not_logged_in: "16-siren-re-engage",
  email_members_who_have_not_logged_in: "16-siren-re-engage",
  bulk_message_to_space: "16-paper-plane-top-right",
  email_all_members_of_a_space: "16-paper-plane-top-right",
  message_on_event_start: "16-calendar-clock-event",
  event_reminder_email: "16-calendar-clock-event",
  message_on_post_comment: "16-at-mention",
  email_members_on_post_comment: "16-at-mention",
  message_on_post_in_space: "16-trending-circle-boost",
  email_members_on_post_in_space: "16-trending-circle-boost",
  rsvp_to_event_message: "16-circle-check-rsvp",
  email_members_on_rsvp_to_event: "16-circle-check-rsvp",
  message_event_attendees: "16-calendar-event",
  email_event_attendees: "16-calendar-event",
  onboarding_feedback: "16-clipboard-feedback",
  email_new_members_to_get_feedback_on_onboarding: "16-clipboard-feedback",
  welcome_message: "16-bubble-heart",
  welcome_email_to_new_members: "16-bubble-heart",
  add_tag_to_paywall_subscriber_subscribed: "16-credit-card",
  message_members_after_trial_completion: "16-clock-alert-trial",
  email_members_after_trial_completion: "16-clock-alert-trial",
  prompt_members_with_past_due_subscription: "16-bubble-alert-payment",
  email_members_with_past_due_subscription: "16-bubble-alert-payment",
  message_new_paywall_subscriber: "16-gift",
  email_new_paywall_subscriber: "16-gift",
  email_on_level_reached: "16-trophy",
  email_on_comment_rejected: "16-rejected-comment",
  message_on_comment_rejected: "16-rejected-comment",
  email_sequence_automation: "16-fork-code",
  email_sequence_bulk_action: "16-fork-code",
  form_submitted_email_sequence: "16-page-check",
};
